import { mapState } from 'vuex';
import { debounce } from '@/assets/js/util';

export const formatOperationMixin = {
  data() {
    return {
      activeImage: '',
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail', 'profile']),
  },
  methods: {
    clickTemplateItem: debounce(function (item) {
      const { imgSrc, show_attr_name, type, ...rest } = item;
      this.activeImage = imgSrc;
      this.selectInfo(show_attr_name);
      this.setFormatInfo(rest);
    }, 300),
    //更改format_info
    setFormatInfo: debounce(function (options) {
      //当前模块要有 key，value
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
      //同步数据
      Object.keys(options).forEach((key) => {
        cvDetail.format_info[key] = options[key];
        if (key === 'line_spacing') {
          //保存行距
          this.$store.commit('editor/setOldLineHeight', options[key]);
        }
      });
      this.$store.commit('editor/setCvDetail', cvDetail);

      //触发保存
      this.submit();
    }, 300),
    // 切换是否显示信息名称
    async selectInfo(value) {
      this.profile.show_attr_name = value;
      try {
        //检测是否有profile数据
        if (this.profile.id && typeof this.profile.id === 'number') {
          let res = await this.$store.dispatch('editor/updateProfileData', {
            payload: this.profile,
          });
          if (res.code === 1000) {
          } else {
            this.$message.success(res.message);
          }
        }
      } catch (error) {}
    },
    // 保存
    async submit() {
      let { kind } = this.cvDetail.basic_info;
      if (kind === 'template' || kind === 'sample') return;
      try {
        const res = await this.$store.dispatch('editor/updateCvDetail', {
          operation_type: 'update_format_info',
          format_info: this.cvDetail.format_info,
          skipCheck: true,
        });
        if (res.code === 1000) {
          // this.$message.success('保存成功');
        } else {
          this.$message.success(res.message);
        }
      } catch (error) {
        this.$message.success('修改失败');
      }
    },
  },
};
